import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useNoteTemplates = () => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["noteTemplates", tenantVal],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(`${tenantVal}/notetemplate`);
      return response.data;
    },
    enabled: !!tenantVal,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    meta: { errorMessage: "Error fetching note templates" },
  });
};
